// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vertical-menu {
  width: 280px;
  background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);
  border-right: 1px solid #dee2e6;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.08);
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: auto;
  z-index: 100;
}

.menu-header {
  padding: 5rem 1.5rem 1.5rem;
  border-bottom: 1px solid #dee2e6;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
}

.menu-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.menu-subtitle {
  font-size: 0.9rem;
  opacity: 0.9;
  margin: 0.5rem 0 0;
  font-weight: 400;
}

.menu-section {
  padding: 1.5rem 0;
}

.menu-section-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0 1.5rem 0.75rem;
  margin: 0;
  border-bottom: 1px solid #e9ecef;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 0.875rem 1.5rem;
  color: #495057;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  position: relative;
}

.menu-item:hover {
  background: rgba(102, 126, 234, 0.08);
  color: #667eea;
  border-left-color: #667eea;
  transform: translateX(4px);
}

.menu-item.active {
  background: rgba(102, 126, 234, 0.12);
  color: #667eea;
  border-left-color: #667eea;
  font-weight: 600;
}

.menu-item-icon {
  font-size: 1.2rem;
  margin-right: 0.875rem;
  width: 20px;
  text-align: center;
  opacity: 0.8;
}

.menu-item:hover .menu-item-icon {
  opacity: 1;
  transform: scale(1.1);
}

.menu-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #dee2e6 50%, transparent 100%);
  margin: 0.5rem 1.5rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .vertical-menu {
    width: 100%;
    height: auto;
    position: relative;
    border-right: none;
    border-bottom: 1px solid #dee2e6;
  }
  
  .menu-header {
    padding: 1.5rem 1rem 1rem;
  }
  
  .menu-title {
    font-size: 1.25rem;
  }
  
  .menu-item {
    padding: 0.75rem 1rem;
  }
  
  .menu-section-title {
    padding: 0 1rem 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VerticalMenu.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,6DAA6D;EAC7D,+BAA+B;EAC/B,yCAAyC;EACzC,aAAa;EACb,eAAe;EACf,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iFAAiF;EACjF,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".vertical-menu {\n  width: 280px;\n  background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);\n  border-right: 1px solid #dee2e6;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.08);\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  top: 0;\n  overflow-y: auto;\n  z-index: 100;\n}\n\n.menu-header {\n  padding: 5rem 1.5rem 1.5rem;\n  border-bottom: 1px solid #dee2e6;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  text-align: center;\n}\n\n.menu-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.menu-subtitle {\n  font-size: 0.9rem;\n  opacity: 0.9;\n  margin: 0.5rem 0 0;\n  font-weight: 400;\n}\n\n.menu-section {\n  padding: 1.5rem 0;\n}\n\n.menu-section-title {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 0 1.5rem 0.75rem;\n  margin: 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.menu-item {\n  display: flex;\n  align-items: center;\n  padding: 0.875rem 1.5rem;\n  color: #495057;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.95rem;\n  transition: all 0.2s ease;\n  border-left: 3px solid transparent;\n  position: relative;\n}\n\n.menu-item:hover {\n  background: rgba(102, 126, 234, 0.08);\n  color: #667eea;\n  border-left-color: #667eea;\n  transform: translateX(4px);\n}\n\n.menu-item.active {\n  background: rgba(102, 126, 234, 0.12);\n  color: #667eea;\n  border-left-color: #667eea;\n  font-weight: 600;\n}\n\n.menu-item-icon {\n  font-size: 1.2rem;\n  margin-right: 0.875rem;\n  width: 20px;\n  text-align: center;\n  opacity: 0.8;\n}\n\n.menu-item:hover .menu-item-icon {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.menu-divider {\n  height: 1px;\n  background: linear-gradient(90deg, transparent 0%, #dee2e6 50%, transparent 100%);\n  margin: 0.5rem 1.5rem;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .vertical-menu {\n    width: 100%;\n    height: auto;\n    position: relative;\n    border-right: none;\n    border-bottom: 1px solid #dee2e6;\n  }\n  \n  .menu-header {\n    padding: 1.5rem 1rem 1rem;\n  }\n  \n  .menu-title {\n    font-size: 1.25rem;\n  }\n  \n  .menu-item {\n    padding: 0.75rem 1rem;\n  }\n  \n  .menu-section-title {\n    padding: 0 1rem 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
